import React from 'react';

const Stack = ({ active, chart_height, chart_width, onClick, round }) => {
  const sorted = active.sort((a, b) => a.value - b.value);
  const cubes = sorted.map(({ label, color, raw, value, id }, index) => {
    return (
      <rect
        onClick={() => onClick({ raw, label })}
        style={{ cursor: 'pointer' }}
        key={id}
        fill={color}
        width={chart_width}
        height={chart_height - value - 10}
        rx="0"
      />
    );
  });

  return (
    <g
      aria-hidden="true"
      strokeLinecap={round ? 'round' : 'butt'}
      strokeLinejoin={round ? 'round' : 'miter'}
    >
      {cubes}
    </g>
  );
};
export default Stack;
